import AppLayout from 'features/ui/app-layout/app-layout';
import { useUserData } from 'hooks/use-user-data';
import React from 'react';
import { Navigate, useLocation } from 'react-router';
import { getPublicAuthRedirectTarget } from 'utils/auth-redirect';

interface Props {
  children?: React.ReactNode;
}

const PrivateRoute: React.FC<Props> = ({ children }) => {
  const { isAuthenticated } = useUserData();
  const location = useLocation();

  // If not authenticated, go to Public Chat page
  if (!isAuthenticated()) {
    return <Navigate to={getPublicAuthRedirectTarget(location)} state={{ from: location }} replace />;
  }

  // Otherwise, wrap the private route content in your AppLayout
  return <AppLayout>{children}</AppLayout>;
};

export default PrivateRoute;
